import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';
import { onWidthResize, offWidthResize } from '../utils/resize.js';
gsap.registerPlugin(ScrollTrigger, SplitText);

export default class StoreHero {
  constructor(container) {
    this.container = container;
    this.title = container.querySelector('.store-hero__title');
    this.subtitle = container.querySelector('.store-hero__subtitle');
    this.media = container.querySelector('.store-hero__media');
    this.image = this.media?.querySelector('img');

    this.init();
  }

  init = () => {
    const tl = gsap.timeline({
      delay: 0.6,
      onComplete: () => {
        [this.titleSplit, this.subtitleSplit].forEach(split => {
          split?.lines.forEach(line => line.replaceWith(...line.childNodes));
        });
      },
    });

    this.initTitleAnimation(tl);
    this.initSubtitleAnimation(tl);
    this.initMediaAnimation(tl);
    this.initParallax();

    onWidthResize(this.onResize);
  };

  initParallax = () => {
    const scrollDefaults = {
      trigger: this.container,
      start: 'top top',
      end: 'bottom+=100px top',
      scrub: true,
    };

    if (this.title) {
      gsap.to(this.titleSplit.chars, {
        yPercent: -100,
        stagger: { each: 0.01, from: 'start' },
        ease: 'none',
        scrollTrigger: scrollDefaults,
      });
    }

    if (this.subtitle) {
      gsap.to(this.subtitleSplit.chars, {
        yPercent: -120,
        stagger: { each: 0.01, from: 'center' },
        ease: 'none',
        scrollTrigger: scrollDefaults,
      });
    }

    
    if (this.image) {
      gsap.to(this.image, {
        yPercent: 15,
        ease: 'none',
        scrollTrigger: scrollDefaults,
      });
    }
  };

  initTitleAnimation = (tl) => {
    if (!this.title) return;
    this.titleSplit = new SplitText(this.title, { type: 'lines,words,chars', linesClass: 'lineParent' });
    tl.fromTo(
      this.titleSplit.words,
      { yPercent: 100 },
      {
        yPercent: 0,
        duration: 1,
        stagger: { each: 0.06, ease: 'power2.out', from: 'start' },
        ease: 'power3.out',
      },
      0
    );
  };

  initSubtitleAnimation = (tl) => {
    if (!this.subtitle) return;
    this.subtitleSplit = new SplitText(this.subtitle, { type: 'lines,words,chars', linesClass: 'lineParent' });
    tl.fromTo(
      this.subtitleSplit.words,
      { yPercent: 100 },
      {
        yPercent: 0,
        duration: 0.8,
        stagger: { each: 0.05, ease: 'power2.out', from: 'start' },
        ease: 'power3.out',
      },
      0.3
    );
  };

  initMediaAnimation = (tl) => {
    if (!this.media) return;
    tl.fromTo(
      this.media,
      { clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)' },
      { clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)', duration: 1.4, ease: 'power2.inOut' },
      0.1
    );

    if (this.image) {
      tl.fromTo(
        this.image,
        { scale: 1.4 },
        { scale: 1.1, duration: 1.6, ease: 'power2.inOut' },
        0.1
      );
    }
  };

  onResize = () => {
    this.titleSplit?.revert();
    this.subtitleSplit?.revert();
    offWidthResize(this.onResize);
  };
}
